export const projectTypes: Map<string, string> = new Map([
  ["fullstack", "Fullstack web app"],
  ["mobile", "Mobile app"],
  ["backend", "RESTful API"],
  ["frontend", "Frontend web app"],
])
